import PropTypes from 'prop-types'
import Typography from '../../common/Typography/index'
import { GoogleMap, Marker, useLoadScript } from '@react-google-maps/api'

const containerStyle = {
  width: '100%',
  height: '200px',
}

const WebVisitorsMap = ({ center, webVisitors = [] }) => {
  const { isLoaded } = useLoadScript({
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
  })

  if (!isLoaded) {
    return (
      <div>
        <Typography variant="body" align="center">
          Loading map...
        </Typography>
      </div>
    )
  }

  return (
    <GoogleMap mapContainerStyle={containerStyle} center={center} zoom={10}>
      {/* Main marker for the center */}
      <Marker position={center} />
      
      {/* Map through webVisitors array to display visitor markers */}
      {webVisitors.map((visitor, index) => (
        <Marker
          key={index}
          position={{ lat: visitor.latitude, lng: visitor.longitude }}
          title={visitor.name}
        />
      ))}
    </GoogleMap>
  )
}

export default WebVisitorsMap

WebVisitorsMap.propTypes = {
  center: PropTypes.shape({
    lat: PropTypes.number.isRequired,
    lng: PropTypes.number.isRequired,
  }).isRequired,
  webVisitors: PropTypes.arrayOf(
    PropTypes.shape({
      latitude: PropTypes.number.isRequired,
      longitude: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
    })
  ),
}

WebVisitorsMap.defaultProps = {
  webVisitors: [],
}